// extracted by mini-css-extract-plugin
module.exports = {"SocialMediaShare":"SocialMediaShare-module--SocialMediaShare--24ioQ","spacer":"SocialMediaShare-module--spacer--1Ve82"};